import React from 'react';
import Icon from './Icon';

export default function KPICard({ title, value, subtitle, iconName, iconColor, iconBg, trend, trendUp }) {
  return (
    <div style={{
      background: 'white', borderRadius: 12, padding: '18px 20px',
      border: '1px solid #E8EAED',
      display: 'flex', flexDirection: 'column', gap: 12,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 11, color: '#6B7280', fontWeight: 600, marginBottom: 5, textTransform: 'uppercase', letterSpacing: '0.05em' }}>{title}</div>
          <div style={{ fontSize: 28, fontWeight: 800, color: '#111827', lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>{value}</div>
          {subtitle && <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 3 }}>{subtitle}</div>}
        </div>
        <div style={{
          width: 44, height: 44, borderRadius: 10,
          background: iconBg || '#F5F6FA',
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          <Icon name={iconName} size={22} color={iconColor || '#6B7280'} />
        </div>
      </div>
      {trend && (
        <div style={{ fontSize: 11, color: trendUp ? '#15803D' : '#B91C1C', display: 'flex', alignItems: 'center', gap: 4, fontWeight: 600 }}>
          <span>{trendUp ? '↑' : '↓'}</span> {trend}
        </div>
      )}
    </div>
  );
}
